import styled from "styled-components";

export const Container = styled.section`
    padding: 32px;
    min-height: calc(100vh - 78px);
    display: flex;
    flex-direction: column;
    gap: 0;
`;